import { Toast } from '../../../components/Common/Toast';
import { StoryPurchaseTypeEnum } from '../../../interfaces/book.interface';
import { HTTPStatusEnum } from '../../../interfaces/log.interface';
import { callAPI } from '../../../services/api.service';

export const getOrdersHistory = async (email: string, currentPage: number) => {
  try {
    if (!email) {
      return;
    }
    const response = await callAPI(`user/get-user-order-history?email=${email}&pageNumber=${currentPage}`);
    if (response?.status === HTTPStatusEnum.OK) {
      return {
        orders: response.orders,
        totalPages: response.totalPages
      };
    } else {
      Toast('Something Went Wrong', true);
      return null;
    }
  } catch (error) {
    Toast('Something Went Wrong', true);
    throw error;
  }
};

export const handleResendConfirmationEmail = async (email: string, orderId: string, orderType: string) => {
  try {
    let response = null;

    switch (orderType) {
      case 'book':
        response = await callAPI(`api/book-purchase/resend-book-purchase-order-confirmation-email`, {
          email,
          orderId
        });
        break;
      case StoryPurchaseTypeEnum.CREDITS:
      case StoryPurchaseTypeEnum.STORY:
        response = await callAPI(`user/resend-image-Credit-purchase-email`, {
          email,
          orderId
        });
        break;
      case 'subscription':
        response = await callAPI(`user/resend-plan-purchase-email`, {
          email,
          orderId
        });
        break;
      default:
        throw new Error('Invalid order type');
    }

    if (response?.status === HTTPStatusEnum.OK) {
      Toast('Confirmation Email Resend Successfully');
      return true;
    } else {
      Toast('Something Went Wrong', true);
      return false;
    }
  } catch (error) {
    Toast('Something Went Wrong', true);
    throw error;
  }
};
